import BackButton from '../generic/BackButton'
import { Wrapper } from '../generic/Layout'
import useTranslation from '../../hooks/useTranslation'
import styled from 'styled-components'

const TitleWrapper = styled(Wrapper)`
    margin-bottom: 0rem;
`

const TitleText = styled.h2`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: var(--font-M);
    font-weight: 600;
    color: ${({ theme }) => theme?.font?.color || '#333'};
`

/**
 * MasterDetailTitle Component
 * 
 * Displays a title bar with back button for MasterDetailView.
 */
const MasterDetailTitle = ({ title, config }) => {
    const { t } = useTranslation()
    
    return (
        <TitleWrapper>
            <TitleText>
                <BackButton config={config} />
                <span>{t(title)}</span>
            </TitleText>
        </TitleWrapper>
    )
}

export default MasterDetailTitle
